import { supabase } from './supabaseClient'

const R2_BASE_URL = process.env.REACT_APP_R2_BASE_URL || 'https://video.airuok.com'

export interface SignedUrlResponse {
  url: string
  expires_at: number
}

export async function getSignedM3u8Url(r2Path: string, ttl = 3600): Promise<string> {
  const { data, error } = await supabase.functions.invoke<SignedUrlResponse>(
    'generate-signed-url',
    { body: { path: r2Path, ttl } }
  )

  if (error) {
    const status = (error as any).context?.status
    if (status === 401) throw new Error('AUTH_REQUIRED')
    throw new Error(`Failed to get signed URL: ${error.message}`)
  }

  if (!data?.url) throw new Error('Invalid response from signed URL service')
  return data.url
}

export function buildM3u8Url(r2Path: string): string {
  return `${R2_BASE_URL}/movie/${r2Path}`
}

export function getVideoR2Path(movie: { r2_path: string }): string {
  return movie.r2_path
}
